import resetPresenceOperation from 'owa-service/lib/operation/resetPresenceOperation';
import ucmaServiceOptions from './ucmaServiceOptions';

export default function resetPresence(): Promise<number> {
    return resetPresenceOperation({}, ucmaServiceOptions);
}
